import { fmhAPI, WORKLIST_API_URL } from 'api/APIBase';

/**
 * Parameters for creating a worklist task.
 * @typedef {Object} TaskCreationParameters
 * @property {string} payer_id - The payer ID.
 * @property {string} segment_id - The segment ID.
 * @property {string} referral_id - The referral ID.
 * @property {string} supplier_npi - The supplier NPI.
 * @property {string} friendly_id - The friendly ID.
 * @property {string} [product_name] - The product name.
 * @property {string} [patient_name] - The patient name.
 * @property {string} [needs_by_date] - The needs by date.
 */

/**
 * Creates a worklist task.
 * @param {Object} options - The options for creating the task.
 * @param {string} options.supplierNpi - The supplier NPI.
 * @param {string} options.taskType - The task type.
 * @param {TaskCreationParameters} options.body - The request body.
 * @returns {Promise<Object>} A promise that resolves to the response JSON.
 */
export async function createWorklistTask({ supplierNpi, taskType, body }) {
    const url = `${WORKLIST_API_URL}/admin/tasks/create/${supplierNpi}/${taskType}`;
    return fmhAPI.base.url(url).post(body).json();
}
